import { render, staticRenderFns } from "./betch-import.vue?vue&type=template&id=32710f4a&scoped=true"
import script from "./betch-import.vue?vue&type=script&lang=js"
export * from "./betch-import.vue?vue&type=script&lang=js"
import style0 from "./betch-import.vue?vue&type=style&index=0&id=32710f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32710f4a",
  null
  
)

export default component.exports